export default __webpack_public_path__ + "static/media/Services.4420ec79.svg";